import type { Theme } from '../../core/types';
import { RyukBehavior } from './behavior';

/** Source rectangles and foot registration stay here, never in the choreography. */
export const ryukTheme: Theme = {
  id: 'ryuk',
  name: 'Ryuk',
  primaryAction: 'feed',
  primaryLabel: 'Ryuk : donner une pomme',
  pointerAction: 'watch',
  greetings: [
    'Tu as une pomme ? Clique sur moi.',
    'Voyons ce que font les humains.',
    'Je reste… ça pourrait être drôle.',
    'Ne fais pas attention à moi.',
    'Un peu de compagnie ?',
    'J’ai tout mon temps.',
  ],
  autoplay: ['fly', 'fly', 'feed', 'juggle', 'watch', 'peek', 'beg', 'phase', 'notebook'],
  createBehavior: (context) => new RyukBehavior(context),
  character: {
    unitHeight: 354,
    frames: [
      [0, 0, 362, 354],
      [362, 0, 362, 353],
      [724, 0, 362, 354],
      [1086, 0, 362, 354],
      [0, 362, 362, 352],
      [362, 362, 362, 362],
      [724, 362, 362, 362],
      [1086, 362, 362, 362],
      [0, 724, 362, 247],
      [362, 724, 362, 345],
      [724, 724, 362, 345],
      [1086, 724, 362, 345],
    ],
  },
  atlases: {
    eating: {
      unitHeight: 700,
      frames: [
        [0, 0, 543, 707],
        [543, 0, 543, 708],
        [1086, 0, 543, 708],
        [1629, 0, 543, 709],
      ],
    },
    flight: {
      unitHeight: 420,
      frames: [
        [0, 0, 647, 558],
        [647, 96, 801, 462],
        [14, 625, 706, 443],
        [740, 568, 695, 501],
      ],
      pivots: [
        { x: 365, y: 554 },
        { x: 445, y: 458 },
        { x: 351, y: 437 },
        { x: 352, y: 494 },
      ],
    },
    apples: {
      unitHeight: 575,
      frames: [
        [123, 85, 541, 573],
        [758, 84, 526, 575],
        [1490, 90, 336, 562],
      ],
    },
  },
  clips: {
    idle: { frames: [0], fps: 1, loop: true },
    watch: { frames: [0], fps: 1, loop: true, lookFrames: { up: 2, down: 1, neutral: 0 } },
    beg: { frames: [3], fps: 1, loop: true },
    laugh: { frames: [4], fps: 1, loop: true },
    juggle: { frames: [5, 6], fps: 5, loop: true, speechClearance: 1.25 },
    perch: { frames: [7], fps: 1, loop: true, scale: 0.8 },
    peek: { frames: [8], fps: 1, loop: true, scale: 0.8 },
    write: { frames: [9, 10], fps: 4, loop: true },
    reach: { frames: [11], fps: 1, loop: true, speechClearance: 1.05 },
    eat: { asset: 'eating', frames: [0, 1, 2, 1, 2, 3, 3], fps: 2.1, loop: false },
    fly: { asset: 'flight', frames: [0, 1, 2, 3], fps: 6, loop: true, speechClearance: 1.35 },
    phase: { frames: [0], fps: 1, loop: true },
  },
  messages: {
    feed: 'Oh… une pomme !',
    juggle: 'Les humains appellent ça du talent.',
    fly: 'La vue est meilleure d’en haut.',
    watch: 'Les humains sont fascinants…',
    peek: 'Tu me cherches ?',
    beg: 'Tu n’aurais pas une pomme ?',
    phase: 'Les murs ? Quels murs ?',
    notebook: 'Voyons ce petit carnet…',
  },
  assets: {
    character: 'character.webp',
    eating: 'eating.webp',
    flight: 'flight.webp',
    apples: 'apples.webp',
  },
};
